import { InputAdornment as MuiInputAdornment } from '@mui/material';
import { type InputAdornmentProps as MuiInputAdornmentProps, styled } from '@mui/material';
import React from 'react';

import { type IconSize, iconSlot } from '../icons/iconSlot';

export type InputAdornmentProps = MuiInputAdornmentProps & {
    /** The px size of an icon placed directly in it; 16 by default, as in the design system's own fields. */
    iconSize?: IconSize;
};

/** MUI's InputAdornment, sizing an icon placed directly in it; lumiquote-frontend's lint bans MUI's own. */
export const InputAdornment = React.forwardRef(function InputAdornment(
    { iconSize = 16, ...props }: InputAdornmentProps,
    ref: React.ForwardedRef<HTMLDivElement>,
): JSX.Element {
    return <SizedInputAdornment ref={ref} iconSize={iconSize} {...props} />;
});

const SizedInputAdornment = styled(MuiInputAdornment, {
    shouldForwardProp: (prop) => prop !== 'iconSize',
})<{ iconSize: IconSize }>(({ iconSize }) => iconSlot(iconSize));
